import { useUserStore } from '../../modules/Auth/stores/authStore';
import { isFreemiumReadOnly } from './freemium';
import { openFreemiumUpsell } from '../stores/freemiumUpsellStore';

/**
 * Versão não-reativa (sem hooks) de `isReadOnly`, para uso em handlers e no
 * interceptor do axios. Lê a store e o pathname no momento da chamada, então
 * funciona inclusive fora do contexto do Router.
 */
export function isFreemiumReadOnlyNow(): boolean {
  const isFreemium = !!useUserStore.getState().user?.isFreemium;
  return isFreemiumReadOnly(isFreemium, window.location.pathname);
}

/**
 * Se o freemium estiver em modo somente-leitura, abre o upsell e retorna
 * `true` (a ação deve ser abortada). Caso contrário retorna `false`.
 */
export function blockIfReadOnly(): boolean {
  if (isFreemiumReadOnlyNow()) {
    openFreemiumUpsell();
    return true;
  }
  return false;
}
